import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('success-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.488 4.3c5.385 0 10.26 2.182 13.788 5.711A19.439 19.439 0 0 1 43.987 23.8a19.44 19.44 0 0 1-5.711 13.788A19.44 19.44 0 0 1 24.487 43.3 19.439 19.439 0 0 1 10.7 37.589a19.44 19.44 0 0 1-5.712-13.79c0-5.384 2.183-10.26 5.712-13.788A19.44 19.44 0 0 1 24.487 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: props.strokeLinejoin,
    d: "M13.688 23.778L22.148 31l13.539-15"
  })));
});